import { render, staticRenderFns } from "./Quantity.vue?vue&type=template&id=2b6cc664&scoped=true"
import script from "./Quantity.vue?vue&type=script&lang=js"
export * from "./Quantity.vue?vue&type=script&lang=js"
import style0 from "./Quantity.vue?vue&type=style&index=0&id=2b6cc664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6cc664",
  null
  
)

export default component.exports